import React, {useEffect, useState} from "react";
import {db} from "../config/firebase-config";
import {addDoc, collection, serverTimestamp} from "firebase/firestore";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {Container} from "react-bootstrap";

import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import "react-date-picker/dist/DatePicker.css";
import "react-calendar/dist/Calendar.css";
import {benachrichtigeMailserver} from "../utils/mailserver";
import {
  EMAIL_HINWEIS,
  getrimmteEmailAdresse,
  istGueltigeEmailAdresse,
} from "../utils/emailAdresse";

/**
 * Die interne Meldung aus der Fahrzeugansicht. Melden darf jeder angemeldete
 * Nutzerkreis, auch `readonly` — wie im Meldeweg gibt es keine
 * Schreibrecht-Sperre.
 */
const ModalMangelIntern = (props) => {
  const today = new Date();

  const [kategorie, setKategorie] = useState("");
  const [kontaktVorname, setKontaktVorname] = useState("");
  const [kontaktNachname, setKontaktNachname] = useState("");
  const [kontaktEmail, setKontaktEmail] = useState("");
  const [kontaktTelefon, setKontaktTelefon] = useState("");
  const [kilometer, setKilometer] = useState("");
  const [beschreibung, setBeschreibung] = useState("");
  const [fahrzeugId, setFahrzeugId] = useState("");
  // Erst wenn der Nutzer das E-Mail-Feld einmal verlassen hat, darf der Hinweis
  // erscheinen — sonst wäre jede halbfertige Eingabe rot.
  const [emailBeruehrt, setEmailBeruehrt] = useState(false);

  useEffect(() => {
    setFahrzeugId(props.fahrzeug.id);
  }, [props.fahrzeug]);

  const emailAdresse = getrimmteEmailAdresse(kontaktEmail);
  const emailIstGueltig = istGueltigeEmailAdresse(kontaktEmail);
  const emailHinweisSichtbar = emailBeruehrt && !emailIstGueltig;

  /**
   * Dieselbe Sperre wie im öffentlichen Meldeweg, mit zwei Unterschieden: Die
   * Datenschutz-Bestätigung gibt es hier nicht, und das Kennzeichen ist durch
   * den Aufrufer fest vorgegeben, also nichts, was der Nutzer vergessen könnte.
   */
  const cannotSave = !(
    kontaktVorname !== "" &&
    kontaktNachname !== "" &&
    kilometer !== "" &&
    emailIstGueltig &&
    kategorie !== "" &&
    beschreibung !== ""
  );

  const changeKm = (e) => {
    let valueTmp = e.target.value;

    const numericString = valueTmp.replace(/\D/g, "");

    // Wenn der String leer ist, gib eine leere Zeichenkette zurück
    if (numericString === "") return "";

    // Wandelt die Zahl in einen Integer um
    const number = parseInt(numericString, 10);

    setKilometer(number.toLocaleString("de-DE"));
  };

  const handleSave = () => {
    if (cannotSave) {
      return;
    }

    const path = "fahrzeuge/" + fahrzeugId + "/maengel";
    const docRef = collection(db, path);
    // const docRef = doc(db, "fahrzeuge");

    let data = {
      new: true,
      status: "offen",
      // Setzt der Server, damit eine falsch gehende Geräteuhr nicht stört.
      datumAngelegt: serverTimestamp(),
      datumLastUpdate: today,
      kategorie: kategorie,
      kontaktName: kontaktVorname + " " + kontaktNachname,
      kontaktEmail: emailAdresse,
      kontaktTelefon: kontaktTelefon,
      priorität: 4,
      kilometer: kilometer,
      historie: [
        {
          beschreibung: beschreibung,
          nutzerkreis: "",
          datum: today,
        },
      ],
    };

    // Atomically add a new region to the "regions" array field.
    addDoc(docRef, data).then((doc) => {
      writeToProtokoll(doc.id);
      benachrichtigeMailserver({fahrzeugId, mangelId: doc.id}).catch((error) => {
        console.error("Mangel-Benachrichtigung fehlgeschlagen:", error);
      });
    });

    handleClose();
  };

  const writeToProtokoll = (id) => {
    const path = "fahrzeuge/" + fahrzeugId + "/protokoll";
    const docRef = collection(db, path);

    let data = {
      status: "neu",
      kategorie: kategorie,
      kontaktName: kontaktVorname + " " + kontaktNachname,
      priorität: 4,
      kilometer: kilometer,
      beschreibung: beschreibung,
      nutzerkreis: "",
      datum: today,
      mangelId: id,
    };

    // Atomically add a new region to the "regions" array field.
    addDoc(docRef, data);
  };

  const handleClose = () => {
    setEmailBeruehrt(false);
    props.close();
  };

  return (
    <>
      <Modal show={props.showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Mangel für Fahrzeug eintragen</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Container>
            <Form>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Kennzeichen</Form.Label>
                    <Form.Select
                      name="modalstatus"
                      onChange={(e) => {
                        setFahrzeugId(e.target.value);
                      }}
                      disabled
                    >
                      <option value={props.fahrzeug.id}>
                        {props.fahrzeug.kennzeichen}
                      </option>
                    </Form.Select>
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Kilometerstand</Form.Label>
                    <Form.Control
                      type="text"
                      id="inputKilomter"
                      value={kilometer}
                      onChange={(e) => {
                        changeKm(e);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Vorname</Form.Label>
                    <Form.Control
                      type="text"
                      id="inputVorname"
                      value={kontaktVorname}
                      onChange={(e) => {
                        setKontaktVorname(e.target.value);
                      }}
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Nachname</Form.Label>
                    <Form.Control
                      type="text"
                      id="inputNachname"
                      value={kontaktNachname}
                      onChange={(e) => {
                        setKontaktNachname(e.target.value);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>E-Mail</Form.Label>
                    {/*
                      `type="email"` allein wegen der Bildschirmtastatur auf
                      Mobilgeräten — geprüft wird mit derselben Regel wie im
                      öffentlichen Meldeweg, nicht mit der schwächeren des
                      Browsers.
                    */}
                    <Form.Control
                      type="email"
                      id="inputEmail"
                      value={kontaktEmail}
                      onChange={(e) => {
                        setKontaktEmail(e.target.value);
                      }}
                      onBlur={() => {
                        setEmailBeruehrt(true);
                      }}
                      isInvalid={emailHinweisSichtbar}
                    />
                    {emailHinweisSichtbar && (
                      <Form.Control.Feedback type="invalid">
                        {EMAIL_HINWEIS}
                      </Form.Control.Feedback>
                    )}
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Telefon</Form.Label>
                    <Form.Control
                      type="text"
                      id="inputTelefon"
                      value={kontaktTelefon}
                      onChange={(e) => {
                        setKontaktTelefon(e.target.value);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Kategorie des Mangels</Form.Label>
                    <Form.Select
                      name="modalstatus"
                      value={kategorie}
                      onChange={(e) => {
                        setKategorie(e.target.value);
                      }}
                    >
                      <option value="">Bitte wählen...</option>
                      {props.kategorien.map((kategorie) => {
                        return (
                          <option
                            value={kategorie.bezeichnung}
                            key={kategorie.id}
                          >
                            {kategorie.bezeichnung}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Form.Group className="mb-3">
                    <Form.Label>Mangelbeschreibung</Form.Label>
                    <Form.Control
                      as="textarea"
                      style={{height: "150px"}}
                      onChange={(e) => {
                        setBeschreibung(e.target.value);
                      }}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Container>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Abbrechen
          </Button>
          <Button
            variant="primary"
            onClick={handleSave}
            disabled={cannotSave}
          >
            Meldung abschicken
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalMangelIntern;
